import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import { GetFlag } from '../utils/featureFlag';
import { resolveIsCommerceUser } from '../utils/commerceUser';

const useIsCommerceUser = (): boolean => {
  const journeyViews = useSelector(
    (state: ApplicationState) => state.user.journeyViews
  );
  const customers = useSelector(
    (state: ApplicationState) => state.customers.customers
  );
  const isManager = useSelector(
    (state: ApplicationState) => state.user.isManager
  );
  const businessType = useSelector(
    (state: ApplicationState) => state.user.businessType
  );
  const migrationFlag = GetFlag('purchase-migration-brdi-brin');

  if (isManager) return true;
  if (migrationFlag && businessType === 'CG') return false;

  return resolveIsCommerceUser(journeyViews, customers, migrationFlag);
};

export default useIsCommerceUser;
